import { PlatformSiteAri } from '@atlassian/ari/platform/site';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

// tech debt: no error handling
export const fetchUserAddProductPermissions = async (cloudId: string) => {
	const response = await fetchJson('/gateway/api/permissions/permitted', {
		method: 'POST',
		body: JSON.stringify({
			resourceId: PlatformSiteAri.create({
				siteId: cloudId,
			}).toString(),
			permissionId: 'add-products',
		}),
		headers: {
			Accept: 'application/json',
		},
	});
	return response;
};
